import { useEffect, useState } from 'react';
import {emitMaintenanceStatus} from "../socket/socket";
import {STORAGE} from "../storage";

const useIntervalMaintenanceStatus = () => {
    // State to track if Soketi is being used
    const [isSoketiActive, setIsSoketiActive] = useState(false);

    // Check if Soketi is active on mount
    useEffect(() => {
        const checkSoketiStatus = async () => {
            const soketiUrl = await STORAGE.get("soketiUrl");
            setIsSoketiActive(!!soketiUrl);
        };
        checkSoketiStatus();
    }, []);

    useEffect(() => {
        // Skip this interval if Soketi is active - maintenance status is handled differently for Soketi
        if (isSoketiActive) {
            // console.log('[INTERVAL_MAINTENANCE] Soketi is active, skipping Socket.IO maintenance interval');
            return;
        }

        const intervalMaintenanceStatus = setInterval(async () => {
            await emitMaintenanceStatus();
        }, 1000 * 300); // Emit every 5 minutes

        return () => clearInterval(intervalMaintenanceStatus);
    }, [isSoketiActive]); // Remove emitMaintenanceStatus from dependencies as it doesn't change
};

export default useIntervalMaintenanceStatus;